import { useDispatch } from 'react-redux';
import {
    Grid, Typography
} from '@mui/material';
import Since from '../Shared/Since';
import Button from '../Buttons/Button';
import pluralize from 'pluralize';

const Header = props => {
    pluralize.addIrregularRule('schema', 'schemas')
    const dispatch = useDispatch()

    return (
        <Grid container className="Header">
            <Grid item xs>
                <Typography variant="h6">{props.type} Count ({props.data?.length})</Typography>
            </Grid>
            <Grid item className="ButtonRow">
                <Since type={pluralize.singular(props.type.toLowerCase())} />
                <Button
                    type="refresh"
                    handler={() => dispatch(props.setData(null))}
                    variant="outlined"
                />
                {!props.hideNew &&
                    <Button
                        type="new"
                        label={`New ${props.type}`}
                        handler={() => window.open(`${pluralize(props.type.toLowerCase())}/new`, '_blank', 'noopener,noreferrer')}
                        variant="contained"
                    />
                }
            </Grid>
        </Grid>
    )
}
export default Header